import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { LocationStrategy } from "@angular/common";
import { WebsiteThemeService } from "../../services/website-theme.service";
import { AuthService } from "../../services/auth.service";
let WhitelistAddressConfirmationMailSentComponent = class WhitelistAddressConfirmationMailSentComponent {
    constructor(sanitizer, router, location, themeService, auth) {
        this.sanitizer = sanitizer;
        this.router = router;
        this.location = location;
        this.themeService = themeService;
        this.auth = auth;
        this.secondColor = '';
        this.accentColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.successColor = '';
        this.backColor = '';
        this.textColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.backColor = this.themeService.getStyleAttribute('modal_back_color');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() { }
    close() {
        this.modal.destroy();
    }
    closeModal() {
        document.documentElement.style.overflowY = '';
        this.modal.destroy();
    }
};
WhitelistAddressConfirmationMailSentComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: Router },
    { type: LocationStrategy },
    { type: WebsiteThemeService },
    { type: AuthService }
];
WhitelistAddressConfirmationMailSentComponent = __decorate([
    Component({
        selector: 'ecd-whitelist-address-confirmation-mail-sent',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./whitelist-address-confirmation-mail-sent.component.html")).default,
    })
], WhitelistAddressConfirmationMailSentComponent);
export { WhitelistAddressConfirmationMailSentComponent };
